import { useState } from 'react'
import { useSearchParams, useNavigate, Link } from 'react-router-dom'
import apiInstance from '../../utils/axios'
import axiosPublic from '../../utils/axios_public';
import { useTranslation } from 'react-i18next';

function CreatePassword() {
    const { t } = useTranslation(); 

    const navigate = useNavigate()
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [isLoading, setIsLoading] =useState(false)
   

    const [searchParams] = useSearchParams()
    const otp = searchParams.get("otp")
    const uidb64 = searchParams.get("uidb64")

    let lang_browser = navigator.language.toLowerCase();
    let lang = localStorage.getItem('language') || (lang_browser.startsWith("en") ? "en" : lang_browser);


    const handlePasswordSubmit = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        if(password !== confirmPassword) {
            alert(t("createPassword.passwords_do_not_match"))
            setIsLoading(false)
        } else {
            setIsLoading(true)
            const formdata = new FormData()

            formdata.append('password', password)
            formdata.append('otp', otp)
            formdata.append('uidb64', uidb64)

            try {
                await axiosPublic.post(`user/password-change/`,formdata).then((res) => {
                    alert("Password changed successfully.")
                    navigate("/login")
                    setIsLoading(false)
                })
                
            } catch(error) {
                alert(t("createPassword.error_changing_password"))
                setIsLoading(false)
                console.log(error)
            }

        }

    }


  return (
    <>
        <div className="form-container-2">
            <div className="form-inner-container-2">
                <h1 className="font">{t("createPassword.create_new_password")}</h1>
                    <p className="desc-text font pd-b5">{t("createPassword.enter_new_password")}</p>
                    <form onSubmit={handlePasswordSubmit}>
                        {/* Email input */}
                        <div className="form-input-container-1">
                            <label className="form-label-1" htmlFor="Full Name">
                            {t("createPassword.password")}
                            </label>
                            <input
                                type="password"
                                name="password"
                                value={password}
                                className="form-input-1 bgc"
                                onChange={(e) => setPassword(e.target.value)}

                            />
                        </div>

                        <div className="form-input-container-1">
                            <label className="form-label-1" htmlFor="Full Name">
                            {t("createPassword.confirm_password")}
                            </label>
                            <input
                                type="password"
                                name="password"
                                value={confirmPassword}
                                className="form-input-1 bgc"
                                onChange={(e) => setConfirmPassword(e.target.value)}

                            />
                        </div>
                        
                        { isLoading === true
                            ?   <button disabled
                                        type='button'
                                        className='form-button-submit-1'                                                                 
                                    >
                                        <span className="mr-2">Processing...</span>
                                </button>
                            :   <button 
                                        type='submit'
                                        className='form-button-submit-1' 
                                    >
                                        <span className="mr-2">{t("createPassword.save_password")}</span>
                                        <i className="fas fa-check-circle" />
                                </button>
                        }
                                                                                                                
                        <div className="">
                            <p className='font'>
                            {t("createPassword.want_to_sign_in")} <Link className="sign-up-link" to="/login">Login</Link>
                            </p>
                        </div>
                    </form>
                </div>                                        
        </div>                
    </>
                       
  )
}

export default CreatePassword